import { apiFetch } from './api';

/**
 * Tout ce qui a une date sur la période : formations vendues, sessions du
 * catalogue, évènements saisis à la main. Les bornes sont des 'aaaa-mm-jj'.
 */
export function getAgenda({ debut, fin }) {
  return apiFetch(`/agenda?debut=${encodeURIComponent(debut)}&fin=${encodeURIComponent(fin)}`);
}

/**
 * Le détail d'une session cliquée dans l'agenda : ses feuilles de présence,
 * avec formateur, participants et émargements. `source` : formation | catalogue.
 */
export function getDetailSeance(source, id) {
  return apiFetch(`/agenda/seances/${encodeURIComponent(source)}/${encodeURIComponent(id)}`);
}

/** Tâches non faites, dues aujourd'hui ou en retard. */
export function getAFaire() {
  return apiFetch('/agenda/a-faire');
}

export function createEvenement(data) {
  return apiFetch('/agenda', { method: 'POST', body: JSON.stringify(data) });
}

export function updateEvenement(id, data) {
  return apiFetch(`/agenda/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

/** Coche (ou décoche) une tâche. */
export function marquerFait(id, fait = true) {
  return apiFetch(`/agenda/${id}/fait`, { method: 'PUT', body: JSON.stringify({ fait }) });
}

export function deleteEvenement(id) {
  return apiFetch(`/agenda/${id}`, { method: 'DELETE' });
}
